import { StatRecord } from "@dashboard-v3/api";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const now = dayjs.utc();
const thirtyDaysAgo = now.subtract(30, "days");
const sixtyDaysAgo = now.subtract(60, "days");

export function filterLastMonth(s: StatRecord) {
  return dayjs(s.date).isAfter(thirtyDaysAgo);
}

export function filterPreviousToLast(s: StatRecord) {
  return (
    dayjs(s.date).isBefore(thirtyDaysAgo) && dayjs(s.date).isAfter(sixtyDaysAgo)
  );
}
